import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { difference } from 'lodash';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';

@Component({
  selector: 'app-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectDropdownComponent),
      multi: true,
    },
  ],
})
export class MultiSelectDropdownComponent implements ControlValueAccessor {
  value!: string;
  valueAfterOpen!: string;
  @Input() btnClasses = 'btn btn-form-control dropdown-toggle btn-block';

  valueAtOpened!: string;

  @Input() placeholder = '';
  @Input() items!: MultiSelectOption[];

  constructor() {}

  onChange = (value: any) => {};

  registerOnTouched(fn: any) {}

  writeValue(obj: string) {
    this.value = obj;
    this.valueAfterOpen = obj;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  checkItem(item: MultiSelectOption) {
    this.toggleValue(item);
  }

  toggleValue(item: MultiSelectOption) {
    if (this.value && this.value.length > 0) {
      const splitted: string[] = this.value.split(',');
      if (typeof item.value === 'string') {
        const index = splitted.findIndex(
          (splittedItem) => splittedItem === item.value
        );
        if (index >= 0) {
          splitted.splice(index, 1);
          this.value = splitted.toString();
        } else {
          this.value = [...splitted, item.value].toString();
        }
      } else {
        if (this.includes(item)) {
          this.value = '';
        } else {
          this.value = item.value.toString();
        }
      }
    } else {
      this.value = item.value.toString();
    }
  }

  includes(item: MultiSelectOption): boolean {
    if (!this.value) {
      return false;
    }
    const splitted: string[] = this.value.split(',');
    if (typeof item.value === 'string') {
      return splitted.includes(item.value);
    } else {
      return difference(item.value, splitted).length === 0;
    }
  }

  getMainText(value: string, items: MultiSelectOption[]) {
    if (!value) {
      return this.placeholder;
    }
    const multiSelected = items.find((item) =>
      typeof item.value === 'object' ? this.includes(item) : false
    );
    if (multiSelected) {
      return multiSelected.label;
    } else {
      return items
        .filter((item) => this.includes(item))
        .map((item) => item.label)
        .toString()
        .replace(/(,)/gm, ', ');
    }
  }

  apply(dropdown: BsDropdownDirective) {
    if (this.value !== this.valueAtOpened) {
      this.onChange?.(this.value);
      this.valueAfterOpen = this.value;
    }
    dropdown.hide();
  }

  onShow() {
    this.valueAtOpened = this.value;
  }

  onHide() {
    this.value = this.valueAfterOpen;
  }
}

export interface MultiSelectOption {
  label: string;
  value: string | string[];
  removeCheckbox?: boolean;
}
